module.exports = __webpack_public_path__ + "static/img/sp10.688b5b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sp10.jpg
// module id = O2B/
// module chunks = 0